import React, { useEffect, useState } from "react";
import AppSidebar from "../../components/AppSidebar";
import AppHeader from "../../components/AppHeader";
import PageHeader from "../../components/PageHeader";
import { useForm } from "react-hook-form";
import RolesService from "../../services/RolesService";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ModulesService from "../../services/ModuleService";
import PermissionService from "../../services/PermissionService";

const CreateRole = () => {
    const [error, setError] = useState('');
    const [alert, setAlert] = useState(false);
    const {register, handleSubmit, formState: {errors}, reset } = useForm();
    const navigate = useNavigate();
    const [modules, setModules] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    useEffect(() => {
        async function getModules() {
            try{
                const result = await ModulesService.getAll();
                setModules(result.data?.data);
            }catch(error){
                console.log("Error in get module", error)
                throw new Error(error.response?.data?.message || error.message);
            }
        }
        async function getPermissions() {
            try{
                const result = await PermissionService.getAll();
                setPermissions(result.data?.data);
            }catch(error){
                console.log("Error in get permission", error)
                throw new Error(error.response?.data?.message || error.message);
            }
        }
        getModules();
        getPermissions();
    }, []);
    const handlePermissionChange = (moduleId, permissionId) => { 
        console.log(moduleId, permissionId);
        setSelectedPermissions(prev => { 
            console.log("===========Previous state:==========", prev);
            const modulePermissions = prev[moduleId] || [];
            const isChecked = modulePermissions.includes(permissionId);
            const newState = {
                ...prev,
                [moduleId]: isChecked ? modulePermissions.filter(item => item !== permissionId) : [...modulePermissions, permissionId]
            }
            console.log("===========New state:==========", newState);
            return newState;
        })
    };
    const onSubmit = async(data) => {
        console.log(data);
        try{
            console.log("Submitting Data:", JSON.stringify(data, null, 2));
            const formattedData = Object.entries(selectedPermissions).map(([moduleId, permissionIds]) => ({
                module_id: Number(moduleId),
                permission_id: permissionIds
            }));
            console.log("Submitting Data:", JSON.stringify(formattedData, null, 2));
            await RolesService.create({
                data:{
                    ...data , 
                    permissions: formattedData  
                }
            });
            toast.success('Role created successfully!');
            reset();
            setTimeout(() => {
                navigate('/role');
            }, 1000);
        }catch(error){
            console.log("Error in creating role", error);
            setAlert(true);
            setError(error.message)
        }
    }
    return (
        <>
        <AppSidebar />
        <div className="main-content">
            <AppHeader/>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-12 ">
                        <PageHeader title="Role" button_label="Back" link_to="/role" className="btn btn-sm btn-primary" />
                        {alert && (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                <strong> {error}!</strong>
                                <button type="button" onClick={() =>setAlert(false)} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        )}
                        <div className="container-fluid">
                            <div className="card row p-4">
                                <form id="customer-form" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        <div className="col-12 col-md-12 mb-4">
                                            <div className="form-group">
                                            <label className="form-label">Name</label>
                                            <input
                                                type="text"
                                                {...register('name', {
                                                required: 'The name field is required.',
                                                validate: value => typeof value === 'string' || 'Name must be a string'
                                                })}
                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            />
                                            {errors.name && <div className="text-danger">{errors.name.message}</div>}
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-12">
                                            <div className="form-group pb-4">
                                            <label className="mb-1 form-label">Label</label>
                                            <input type="text" {...register('label' )} className={`form-control ${errors.label ? 'is-invalid' : ''}`}/>
                                            {errors.label && <div className="invalid-feedback">{errors.label.message}</div>}
                                            </div>
                                        </div>
                                        {modules.length > 0 ?  
                                            <>
                                                <div className="table-responsive vh-100">
                                                    <table className="table table-sm table-nowrap card-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="sticky-top sticky-left">MODULE</th>
                                                                {
                                                                    permissions.length > 0 ? ( 
                                                                        <>
                                                                        <th className="text-center sticky-top">
                                                                            <div className="form-check">
                                                                                <label className="form-check-label" htmlFor={`switch_${module.id}_all`}></label>
                                                                                <small className="text-body-secondary">
                                                                                    {'all'}
                                                                                </small>
                                                                            </div>
                                                                        </th>
                                                                        {permissions.map((permission) => (
                                                                            <th className="text-center sticky-top" key={`head_${permission.id}`} >
                                                                                <div className="form-check">
                                                                                    <label className="form-check-label" htmlFor={`switch_${module.id}_${permission.id}`}></label>
                                                                                    <small className="text-body-secondary">
                                                                                        {permission.name || '-'}
                                                                                    </small>
                                                                                </div>
                                                                            </th>
                                                                        ))}
                                                                        </>
                                                                    ) 
                                                                    :
                                                                    <th>--</th>
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody className="fs-base">
                                                            {
                                                                modules.map((module) => (
                                                                    <tr key={`module_${module.id}`}>
                                                                        <td className="sticky-left">
                                                                            <div className="form-group">
                                                                                <label className="form-label">
                                                                                    {module.label || '-'}
                                                                                </label>
                                                                            </div>
                                                                        </td>
                                                                        {
                                                                            permissions.length > 0 ? (
                                                                                <>
                                                                                <td className="text-center" key={`module_${module.id}_all`}>
                                                                                    <div className="form-check d-inline-block me-n3">
                                                                                        <input 
                                                                                            className="form-check-input" 
                                                                                            type="checkbox" 
                                                                                            id={`switch_all_${module.id}`}
                                                                                            checked={selectedPermissions[module.id]?.length === permissions.length}
                                                                                            onChange={() => {
                                                                                                const allPermissions = permissions.map(permission => permission.id);
                                                                                                setSelectedPermissions(prev => ({
                                                                                                    ...prev,
                                                                                                    [module.id]: prev[module.id]?.length === permissions.length ? [] : allPermissions
                                                                                                }));
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                {permissions.map((permission) => (
                                                                                    <td className="text-center" key={`module_${module.id}_perm_${permission.id}`}>
                                                                                        <div className="form-check d-inline-block me-n3">
                                                                                            <input className="form-check-input" type="checkbox" id={`switch_${module.id}_${permission.id}`} checked={selectedPermissions[module.id]?.includes(permission.id) || false} onChange={() => handlePermissionChange(module.id, permission.id)}/>
                                                                                        </div>
                                                                                    </td>
                                                                                ))}
                                                                                </>
                                                                            )
                                                                            :  <td>"-"</td>
                                                                        }
                                                                    </tr>
                                                                    ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                            : 
                                            <div>No data</div>}
                                        </div>
                                    <button type="submit" className="btn btn-primary">
                                    Save
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ToastContainer/>
        </>
    )
}
export default CreateRole